/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Usage_S42_Item_2Inputs */

const es_privacy_policy_usage_s42_item_2 = /** @type {(inputs: Privacy_Policy_Usage_S42_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprender necesidades para priorizar nuevas funcionalidades`)
};

const en_privacy_policy_usage_s42_item_2 = /** @type {(inputs: Privacy_Policy_Usage_S42_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Understand needs to prioritize new features`)
};

/**
* | output |
* | --- |
* | "Understand needs to prioritize new features" |
*
* @param {Privacy_Policy_Usage_S42_Item_2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_usage_s42_item_2 = /** @type {((inputs?: Privacy_Policy_Usage_S42_Item_2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Usage_S42_Item_2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_usage_s42_item_2(inputs)
	return en_privacy_policy_usage_s42_item_2(inputs)
});
export { privacy_policy_usage_s42_item_2 as "privacy_policy.usage.s42_item_2" }